import { HFlow, Icon, Text, VFlow } from 'bold-ui'
import { css } from 'emotion'
import React from 'react'

interface IconDateRangeProps {
  hSpacing?: number
  vSpacing?: number
  startDate: string
  endDate: string
}

export function IconDateRange(props: Readonly<IconDateRangeProps>) {
  const { startDate, endDate, hSpacing = 0.5, vSpacing = 0.2 } = props

  return (
    <HFlow
      hSpacing={hSpacing}
      alignItems='center'
      style={css`
        min-width: 8.6rem;
      `}
    >
      <Icon icon='calendarFilled' fill='primary' size={1} />
      <VFlow vSpacing={vSpacing}>
        <Text>
          De
          <Text fontWeight='bold'> {startDate}</Text>
        </Text>
        <Text>
          até
          <Text fontWeight='bold'> {endDate}</Text>
        </Text>
      </VFlow>
    </HFlow>
  )
}
